import format from "date-fns/format";
import locale from "date-fns/locale/ja";

// 2019年5月21日(火) 15:00
export function formatLong(date: Date): string {
  return format(date, "PPP(eee) p", { locale });
}

// 2019/05/21
export function formatShort(date: Date): string {
  return format(date, "PP", { locale });
}
